<template>
  <div>
      <!-- メイン -->
    <v-main>
      <v-container>
        <!-- <v-card flat> -->
          <v-row >
            <v-col cols="12" align-self="center">
              <v-row class="py-2">
                <v-col cols="12" class="d-flex align-center justify-center text-h4 text-xl-h3">
                  <span class="vf-font-title" style="font-weight: bold; font-size: 0.8em;">本人確認用書類のご登録</span>
                </v-col>
              </v-row>

              <v-row class="mt-10 mb-1">
                <v-col cols="1"></v-col>
                <v-col cols="10" class="d-flex align-center justify-center text-h6 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4">
                  <span> 申請には本人を確認することができる書類が必要となります。以下のなかから一つお選びください。</span>
                </v-col>
                <v-col cols="1"></v-col>
              </v-row>

              <v-row >
                <v-col cols="12">
                  <v-sheet min-height="4vh" color="transparent"></v-sheet>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="2"></v-col>
                <v-col cols="8" class="d-flex align-center justify-center" >
                  <v-radio-group v-model="selectedAppDocKbn" class="mx-2" style="transform:scale(1.5);">
                  <v-radio class="mb-6"
                    v-for="(item, index) in appDocKbnInfo"
                    color="indigo"
                    :key="index"
                    :label="item.name"
                    :value="item.cd"
                    
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="2"></v-col>
              </v-row>

              <v-row class="mt-10 mb-1"> 
                <v-col cols="12" class="d-flex align-center justify-center">
                  <v-btn x-large color="success" min-height="80px" :width="imageNextBtnWidth" dark @click="next()" :disabled="initializeErr" class="text-h5">次へ</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        <!-- </v-card> -->
      </v-container>
    </v-main>
    <!-- <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doyes="dlgMsg.doYes"/> -->
    <!-- <comMessage :msg="dlgMsg.msg" :is-open="dlgMsg.isOpen" :do-yes="dlgMsg.doYes"/> -->
    <comMessage :msg="dlgMsgErr.msg" :isOpen="dlgMsgErr.isOpen" :doYes="dlgMsgErr.doYes"/>
    
  </div>
</template>
<script>
import Constants from "../common/constantsVf";
import Utils from "../common/utils";
export default {
  name: "VFVerifyDocSelect",
  data() {
    return {
      screenTitle: "確認書類選択",
      screenId: "APA200",
      appDocKbnInfo: [],
      selectedAppDocKbn: "",

      initializeErr: false,

      // dlgMsg: {
      //   msg: "",
      //   isOpen: false,
      //   doYes: () => {
      //     this.dlgMsg.isOpen = false;
      //   },
      // },
      dlgMsgErr: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgErr.isOpen = false;
        },
      },
    };
  },
  computed: {
    imageNextBtnWidth() {
      let bp = this.$vuetify.breakpoint.name;
      if (bp == "xs" || bp == "sm") {
        return "98%";
      } else if (bp == "md" || bp == "lg" || bp == "xl") {
        return "30%";
      } else {
        return "98%";
      }
    },
  },
  created() {
    
  },
  mounted() {
     
     this.getAppDocList();
    
  },

  methods: {

    /**
     * 確認書類取得
     */        
    getAppDocList: function() {
      this.appDocKbnInfo =  this.$store.getters["vfMaster/getAppDocKbnList"];
    if (this.appDocKbnInfo.length == 0) {
         this.dlgMsgErr.msg = this.$i18n.t(this.$i18n.t('msg.err.cm100', ['確認書類']));
         this.dlgMsgErr.isOpen = true;
         this.initializeErr = true;
      }
    },

    next: function() {
      // 入力値チェック
      let chkRslt = this.unitCheckForNext();
      if (!chkRslt) {
        return;
      }
      // 確認申請登録
      let selectedAppDocKbnInfo = {cd: this.selectedAppDocKbn, name: this.getDocName(this.selectedAppDocKbn)}
      this.$store.dispatch("vfAppInfo/setSelectedAppDocKbnInfo", selectedAppDocKbnInfo);
      let receiptNo = this.$store.getters["vfAppInfo/getReceiptNo"];
      this.register(receiptNo, selectedAppDocKbnInfo);
    },
    unitCheckForNext: function() {
      let retVal = true;
      let errList = new Array();
      this.$i18n
      if (this.selectedAppDocKbn == "") {
        errList.push(this.$i18n.t('msg.err.apv072', ['確認書類']));
      }
      if (errList.length > 0) {
        retVal = false;
        this.dlgMsgErr.msg = Utils.createMsgViewString(errList);
        this.dlgMsgErr.isOpen = true;
      }
      return retVal;
    },
    getDocName: function(selectedCd) {
      let retVal = "";
      let appDocKbnList =  this.$store.getters["vfMaster/getAppDocKbnList"];
      let searchArry = "";
      if (selectedCd != "") {
        searchArry = appDocKbnList.find((v) => v.cd === selectedCd);
      }
      if (searchArry != null) {
        retVal = searchArry.name;
      }
      return retVal;
    },

    /*
    * 確認申請登録
    */
    register: async function(receiptNo, selectedAppDocKbnInfo){
      // サービス呼び出し
      let responseData = null;
      let apiErrorInfo = null;
      let apiurl = Constants.URL_API_APA200P01;
      // 検索条件データ
      let data = JSON.stringify(this.registerVerifyAppData(receiptNo, selectedAppDocKbnInfo));
      try {
        let response = await this.$axios.post(apiurl, data,
            {
              headers: {"content-type": "application/json"}, 
              responseType: "json",
            });
         responseData = response.data

      } catch(error) {
          apiErrorInfo = error;
          this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm110', ['確認書類の登録']);
          this.dlgMsgErr.isOpen = true;
          this.initializeErr = true;
      } 
      // 完了メッセージ表示
      this.showDialogMsgAfterAPICall(this.dlgMsgErr, apiErrorInfo, responseData);
    },

     /*
    * 登録用リクエストデータ生成
    */  
    registerVerifyAppData: function(receiptNo, selectedAppDocKbnInfo){
      let reqData = {};
      reqData['receiptNo'] = receiptNo;
      reqData['selectDocument'] = selectedAppDocKbnInfo;
      return reqData;
    },

    /*
    * 完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(dialog, apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        dialog.msg = this.$i18n.t('msg.err.cm110', ['確認書類']);
        dialog.isOpen = true;
        this.initializeErr = true;
        return hasError;
      }
      // API処理異常
      if (responseData.statusCd === 500) {
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          dialog.msg = Utils.createMsgViewStringForErrList(errorList);
          dialog.isOpen = true;
        }else{
          dialog.msg = responseData.message ;
          dialog.isOpen = true;
          
        }
        this.initializeErr = true;
        return hasError;
      } else {
        // 遷移
      this.$router.push( this.$router.resolve({ name: 'APA300' }).href);
      }
    },


   },
  }
</script>
<style scoped>

</style>